import { normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("button", {
    ref: "submitButtonRef",
    type: "button",
    class: _normalizeClass(["btn-mkto-submit", {'ready': $setup.submitState.totalDoneRequired }]),
    role: "button",
    onMouseover: $setup.submitButtonHover,
    onClick: _cache[0] || (_cache[0] = $event => $setup.showSubmitSpinner())
  }, [
    _createVNode($setup["loader"], {
      class: _normalizeClass({active: $setup.btnSpinner})
    }, null, 8 /* PROPS */, ["class"]),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(" Submit Form "),
      _createCommentVNode("fall back when slot is not passed")
    ])
  ], 34 /* CLASS, NEED_HYDRATION */))
}